import { EventEmitter, Injectable } from "@angular/core";
import { Analise } from "src/app/dashboard/models/analise";
import { MapConfig } from "../models/map-config";
import { interval } from 'rxjs';


@Injectable({ providedIn: 'root' })

export class routerToMainService {

  instantAnalysisMapConfig: MapConfig;

    mapConfigChanged = new EventEmitter<MapConfig>();
    requestAnalysis = new EventEmitter<any>();
    routerIdentity = new EventEmitter<string>();
    getTimeRT = new EventEmitter<boolean>();
    recievedAnalysis : Analise;

    /**
     * Muda a MapCOnfig presente no mainmenu
     * @param mapConfig Configuração de mapa atual
     */
    changePersistentMapConfig(mapConfig : MapConfig) {
      this.mapConfigChanged.emit(mapConfig);
    }

    /**
     * 
     * @param identity Id do link que o aplicativo esta agr, Ex. 1 = Analise instantânea, utilizado primáriamente para impedir da toolbar não entender qual link está
     */
    enforceRouterIdentity(identity:string){
      this.routerIdentity.emit(identity);
    }

    /**
     * Pede para o mapa montar um objeto de Analise com base nas configurações do mapa atual
     */
    requestAnalysisToMap(){
      this.requestAnalysis.emit()
    }

}
